// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getLoyaltyThemeColor } from '@tcp/core/styles/themes/loyaltyTheme';

const RewardsPointsStatusBarStyle = css`
  .progress-container {
    height: 10px;
    border-radius: 5px;
    background-color: ${(props) => props.theme.colorPalette.userTheme.mprPrimary};
    width: 100%;
    overflow: hidden;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0;
  }

  .progressbar-rewards {
    background-color: ${(props) => props.theme.colorPalette.userTheme.mpr};
    width: 0%;
    height: 100%;
    position: relative;
  }

  .progress-container_plcc {
    height: 10px;
    border-radius: 5px;
    background-color: ${(props) => props.theme.colorPalette.userTheme.plccLight};
    width: 100%;
    overflow: hidden;
  }

  .progressbar-rewards_plcc {
    background-color: ${(props) => props.theme.colorPalette.userTheme.plcc};
    width: 0%;
    height: 100%;
    position: relative;
  }

  .table-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .table-item {
    border-right: 1px solid ${(props) => props.theme.colorPalette.gray[600]};
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:last-child {
      border: none;
    }

    @media ${(props) => props.theme.mediaQuery.medium} {
      border: none;
    }
  }

  .current-points {
    white-space: nowrap;
  }
  .my-rewards {
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }

  .my-rewards p {
    margin-left: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.SM};

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-left: 0;
    }
  }
  .rewards-status-progress-wrapper {
    border: 2px solid ${(props) => props.theme.colors.PRIMARY.LIGHTERGRAY};
    height: 10px;
    border-radius: 10px;
  }
  .rewards-status-progress {
    width: ${(props) => (props.currentPoints ? `${props.currentPoints}%` : '1%')};
    height: 10px;
    background: ${(props) => getLoyaltyThemeColor(props.isLoyaltyTieringEnabled, props.currentTier, props.plccUser, props.theme.colorPalette)};
    border-radius: 10px 0px 0px 10px;
    max-width: 100%;
  }
  .to-next-reward {
    border-right: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTERGRAY};
    flex-basis: 42%;
    color: ${(props) => props.theme.colorPalette.gray[900]};
  }
  .rewards-point {
    flex-basis: 25%;
    color: ${(props) => props.theme.colorPalette.gray[900]};
  }
  .my-rewards-item {
    flex-basis: 33%;
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    color: ${(props) => props.theme.colorPalette.gray[900]};
  }
  .view-my-rewards-wrapper {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2} 0px
      ${(props) => props.theme.spacing.ELEM_SPACING.XS_1} 0px;
  }
  .view-my-rewards {
    text-decoration-line: underline;
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
  }
  .rewards-dollar-symbol {
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
  }
`;

export default RewardsPointsStatusBarStyle;
